import { render, staticRenderFns } from "./BackerCenterDashboardView.vue?vue&type=template&id=2b06f322"
import script from "./BackerCenterDashboardView.vue?vue&type=script&lang=js"
export * from "./BackerCenterDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports